<template>
  <div>
    
    
    <div>
      
      <a-table v-if="!isMobile" :columns="columns" :data-source="dataBillList" bordered>
        <template slot="status" slot-scope="text, record">
          
          <a-timeline>
            <a-timeline-item color="blue" v-if="record.status === 'PENDING'">
              <strong>Pending Payment</strong><br>
              <small>Waiting for customer to complete payment</small>
            </a-timeline-item>
            <a-timeline-item color="green" v-if="['PAID', 'READY_FOR_PARKING'].includes(record.status)">
              <strong>Payment Completed</strong><br>
              <small>Payment has been successfully received</small>
            </a-timeline-item>
            <a-timeline-item color="orange" v-if="record.status === 'PAID'">
              <strong>Staff Review</strong><br>
              <small>Waiting for staff confirmation</small>
            </a-timeline-item>
            <a-timeline-item color="green" v-if="record.status === 'READY_FOR_PARKING'">
              <strong>Approved</strong><br>
              <small>Payment verified and approved by staff</small>
            </a-timeline-item>
          </a-timeline>
        </template>
        <template slot="method" slot-scope="text, record">
          <div v-if="record.status === 'PAID'">
            <small class="mt-0 mb-0 font-web">ref1 ::</small>
            <p class="mt-0 mb-0 font-web">{{ record.dataDeJson.ref1 }}</p>
            <small class="mt-0 mb-0 font-web">ref2 ::</small>
            <p class="mt-0 mb-5 font-web">{{ record.dataDeJson.ref2 }}</p>
            <hr>
            <small class="mt-0 mb-0 font-web">วันที่จ่ายเงิน ::</small>
            <p class="mt-0 mb-0 font-web">{{ moment(record.transaction_datetime).locale('th').add('year',
              543).format('DD / MMMM / YYYY HH:mm') }}</p>
            <small class="mt-0 mb-0 font-web">ชำระโดย ::</small>
            <p class="mt-0 mb-0 font-web">{{ record.payer_name }}</p>
          </div>
          <div v-else>
            <small class="mt-0 mb-0 font-web">ref1 ::</small>
            <p class="mt-0 mb-0 font-web">{{ record.dataDeJson.ref1 }}</p>
            <small class="mt-0 mb-0 font-web">ref2 ::</small>
            <p class="mt-0 mb-5 font-web">{{ record.dataDeJson.ref2 }}</p>
            <hr>
            <small class="mt-0 mb-0 font-web text-danger">วันที่กำหนดจ่ายเงิน ::</small>
            <p class="mt-0 mb-0 text-danger font-web">{{ moment(record.expiryDate).locale('th').add('year',
              543).format('DD / MMMM / YYYY HH:mm') }}</p>
          </div>
        </template>
        <template slot="amount_paid" slot-scope="text, record">
          <h4 class="mt-0 mb-0 font-web">{{ record.amount_paid }}</h4>
        </template>
        <template slot="car" slot-scope="text, record">
          <div class="car-info font-web">
            <div class="mb-10 info-row">
              <span class="info-title"><a-icon type="bars" class="mr-5" /> License Plate</span>
              <h5 style="font-size: 20px !important;font-weight: 900 !important;" class="mt-0 mb-0">
                {{ record.car_details.license_plate_prefix }} {{ record.car_details.license_plate_number }}
              </h5>
            </div>
            <div class="mb-10 info-row">
              <span class="info-title mr-10"><a-icon type="car" class="mr-5" />Model</span>
              <span style="font-size: 14px;font-weight: 700;" class="info-value">{{ record.car_details.brand }} {{
                record.car_details.model }}</span>
            </div>
          </div>
        </template>
      </a-table>

      <a-list v-else :data-source="dataBillList" item-layout="vertical">
        <a-list-item slot="renderItem" slot-scope="record">
          <a-card bordered class="mb-10">
            <div class="mb-10">
              <strong>
                <a-icon type="car" /> {{ record.car_details.brand }} {{ record.car_details.model }}
              </strong>
              <div style="font-size:18px;font-weight:900">
                {{ record.car_details.license_plate_prefix }}
                {{ record.car_details.license_plate_number }}
              </div>
            </div>
            <div class="mb-10">
              <span>Amount</span>
              <h3 class="mt-0 mb-0">{{ record.amount_paid }} ฿</h3>
            </div>
            <a-timeline class="mt-10">
              <a-timeline-item color="blue" v-if="record.status === 'PENDING'">
                <strong>Pending Payment</strong><br>
                <small>Waiting for customer to complete payment</small>
              </a-timeline-item>
              <a-timeline-item color="green" v-if="['PAID', 'READY_FOR_PARKING'].includes(record.status)">
                <strong>Payment Completed</strong><br>
                <small>Payment has been successfully received</small>
              </a-timeline-item>
              <a-timeline-item color="orange" v-if="record.status === 'PAID'">
                <strong>Staff Review</strong><br>
                <small>Waiting for staff confirmation</small>
              </a-timeline-item>
              <a-timeline-item color="green" v-if="record.status === 'READY_FOR_PARKING'">
                <strong>Approved</strong><br>
                <small>Payment verified and approved by staff</small>
              </a-timeline-item>
            </a-timeline>
            <div class="mt-10">
              <small>ref1</small>
              <p class="mb-0">{{ record.dataDeJson.ref1 }}</p>
              <small>ref2</small>
              <p class="mb-5">{{ record.dataDeJson.ref2 }}</p>
              <div v-if="record.status === 'PAID'">
                <small>Paid Date</small>
                <p class="mb-0">
                  {{ moment(record.transaction_datetime)
                    .locale('th')
                    .add('year', 543)
                    .format('DD / MMMM / YYYY HH:mm') }}
                </p>
                <small>Payer</small>
                <p class="mb-0">{{ record.payer_name }}</p>
              </div>
              <div v-else>
                <small class="text-danger">Expiry Date</small>
                <p class="text-danger mb-0">
                  {{ moment(record.expiryDate)
                    .locale('th')
                    .add('year', 543)
                    .format('DD / MMMM / YYYY HH:mm') }}
                </p>
              </div>
            </div>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    dataBillList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      columns: [
        {
          title: "ข้อมูลรถยนต์",
          dataIndex: "car",
          key: "car",
          align: "left",
          scopedSlots: { customRender: "car" }
        },
        {
          title: "ข้อมูลการชำระเงิน",
          dataIndex: "method",
          key: "method",
          align: "left",
          scopedSlots: { customRender: "method" }
        },
        {
          title: "จำนวนเงิน (บาท)",
          dataIndex: "amount_paid",
          key: "amount_paid",
          align: "right",              // ชิดขวา
          scopedSlots: { customRender: "amount_paid" }
        },
        {
          title: "สถานะ",
          dataIndex: "status",
          key: "status",
          align: "left",             // ตรงกลาง
          scopedSlots: { customRender: "status" }
        }
      ],
      isMobile: false
    };
  },

  computed: {
    totalAmount() {
      return this.paymentHistory.reduce((sum, item) => sum + item.amount, 0);
    }
  },

  mounted() {
    this.checkScreen()
    globalThis.addEventListener('resize', this.checkScreen)
  },
  beforeDestroy() {
    globalThis.removeEventListener('resize', this.checkScreen)
  },
  methods: {
    checkScreen() {
      this.isMobile = globalThis.innerWidth < 768
    }
  }



};
</script>

<style scoped>
.total-box {
  text-align: right;
  margin-top: 20px;
  font-weight: bold;
}
</style>


<style>
.ant-table-thead>tr>th {
  background: #f0f0f0 !important;
  /* สีเทา */
  font-size: 16px !important;
  /* ขยายฟอนต์หัวตาราง */
  font-weight: 600 !important;
  /* หนาขึ้น */
  text-align: center;
  color: #000000;
  /* จัดกลาง (ถ้าต้องการ) */
}
</style>